import { render, staticRenderFns } from "./BoxH.vue?vue&type=template&id=396e2502&scoped=true&lang=pug"
import script from "./BoxH.vue?vue&type=script&lang=js"
export * from "./BoxH.vue?vue&type=script&lang=js"
import style0 from "./BoxH.styl?vue&type=style&index=0&id=396e2502&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e2502",
  null
  
)

export default component.exports